import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';



 gsap.registerPlugin(ScrollTrigger);



if(document.querySelector('.case-studies__slider')){
  let duration = 1,
    sections = gsap.utils.toArray(".case-study__slider"),
    sectionIncrement = duration / (sections.length),
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".horizontal-scroll",
        pin: true,
        scrub: true, 
        snap: 1 / (sections.length - 1),
        start: "top top",
        end: () => "+=" + document.querySelector(".case-studies__slider").offsetWidth,
      }
    });


  tl.to(sections, {
    xPercent: -100 * (sections.length -1),
    duration: duration,
    delay:0.25,
    ease: "none"
  });

  sections.forEach((section, index) => {
    let imgElements = section.querySelectorAll('.case-study__image img');
    
    imgElements.forEach((imgElement, imgIndex) => {
      let tween = gsap.from(imgElement, {
        opacity: 0,
        scaleX:0,
        scaleY:0,
        duration: 1,
        transformOrigin: "top left",
        delay:0.5,
        force3D: true,
        paused: true,
        ease: "sine.inOut"
      });

      addSectionCallbacks(tl, {
        start: sectionIncrement * (index - 0.99),
        end: sectionIncrement * (index + 0.99),
        onEnter: () => tween.play(),
      });

      index || tween.progress(1);
    });
  });

}


if(document.querySelector('.team__grid')){
  gsap.from(".team__grid-item-image", {
    scrollTrigger: {
      trigger: ".horizontal-scroll",
      scrub: true,
      start: "top center",
      end: "top top"
    },
    scaleX:0,
    scaleY:0,
    transformOrigin: "center center", 
    ease: "sine.inOut"
  });

  gsap.from(".team__grid-item-title", {
    scrollTrigger: {
      trigger: ".horizontal-scroll",
      scrub: false,
      start: "top center",
      end: "top top"
    },
    paddingRight:0,
    transformOrigin: "center center", 
    ease: "sine.inOut"
  });

}


if (document.querySelector('.stages__item')) {

  let panels = gsap.utils.toArray(".stages__item");
  let tops = panels.map(panel => ScrollTrigger.create({trigger: panel, start: "top top"}));
  
  panels.forEach((panel, i) => {
    ScrollTrigger.create({
      trigger: panel,
      start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", 
      pin: true, 
      pinSpacing: false 
    });
  });
  
  ScrollTrigger.create({
    snapTo: (progress, self) => {
      let panelStarts = tops.map(st => st.start),
      snapScroll = gsap.utils.snap(panelStarts, self.scroll());
      console.log(snapScroll); // Log the snap positions
      return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll);
    },
  });
  
  
}


function addSectionCallbacks(timeline, { start, end, param, onEnter, onLeave, onEnterBack, onLeaveBack }) {
  let trackDirection = animation => {
    let onUpdate = animation.eventCallback("onUpdate"),
      prevTime = animation.time();
    animation.direction = animation.reversed() ? -1 : 1;
    animation.eventCallback("onUpdate", () => {
      let time = animation.time();
      if (prevTime !== time) {
        animation.direction = time < prevTime ? -1 : 1;
        prevTime = time;
      }
      onUpdate && onUpdate.call(animation);
    });
  },
    empty = v => v;
  timeline.direction || trackDirection(timeline);
  start >= 0 && timeline.add(() => ((timeline.direction < 0 ? onLeaveBack : onEnter) || empty)(param), start);
  end <= timeline.duration() && timeline.add(() => ((timeline.direction < 0 ? onEnterBack : onLeave) || empty)(param), end);
}

if(document.querySelector('.horizontal-gallery')){
  let duration = 1,
    images = gsap.utils.toArray(".horizontal-gallery__image"),
    sectionIncrement = duration / (images.length),
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".horizontal-scroll-carousel",
        pin: true,
        scrub: true,
        snap: 1 / (images.length - 1),
        start: "top top",
        end: () => "+=" + document.querySelector(".horizontal-gallery").offsetWidth,
      }
    });
  
  
  tl.to(images, {
    xPercent: -100 * (images.length -1),
    duration: duration,
    ease: "none"
  });

  
}
  

if(document.querySelector('.case-studies__slider')){
// Check if it's a touch device
const isTouchDevice = 'ontouchstart' in window;

const createCursorFollower = () => {
  const $el = document.querySelector('.cursor-follower');
  const slider = document.querySelector('.case-studies__slider');

  // Each time the mouse coordinates are updated,
  // we need to pass the values to gsap in order
  // to animate the element
  slider.addEventListener('mouseenter', () => {
    // Event listener for mousemove only when hovering over the slider
    window.addEventListener('mousemove', updateCursor);
  });

  slider.addEventListener('mouseleave', () => {
    // Remove the event listener when mouse leaves the slider
    window.removeEventListener('mousemove', updateCursor);
    // Hide the cursor element
    gsap.to($el, {
      duration: 0.7,
      opacity: 0,
    });
  });

  // Hiding the cursor element when the mouse cursor
  // is moved out of the page
  document.addEventListener('mouseleave', () => {
    window.removeEventListener('mousemove', updateCursor);
    gsap.to($el, {
      duration: 0.7,
      opacity: 0,
    });
  });

  function updateCursor(e) {
    const { target, x, y } = e;
    // Check if target is inside a link or button
    const isTargetLinkOrBtn = target?.closest('a') || target?.closest('button');

    // Find the span tag within the '.cursor-follower' div
    const $span = $el.querySelector('span');

    // Set opacity for the span based on the target
    gsap.to($span, {
      opacity: isTargetLinkOrBtn ? 1 : 0, // Set opacity to 1 if the target is a link or button
    });

    // GSAP config for the cursor
    gsap.to($el, {
      x: x + 12,
      y: y + 12,
      duration: 0.7,
      ease: 'power4',
      opacity: isTargetLinkOrBtn ? 0.8 : 1,
      transform: `scale(${isTargetLinkOrBtn ? 2 : 1})`,
    });
  }
};

// Only invoke the function if it isn't a touch device
if (!isTouchDevice) {
  createCursorFollower();
}

}